import React, { Component } from 'react';
import Modal from 'react-awesome-modal';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import _ from 'lodash';

import Button from '../../../shared/button/components/button';
import PageHeader from '../../../shared/page-header/components/page-header';
import CloseBtn from '../../../shared/close-btn/components/close-btn';
import DefaultInput from '../../../shared/default-input/components/default-input';
import DefaultSelect from '../../../shared/default-select/components/default-select';
import campaignsConstants from '../constants/campaigns-constants';
import Helpers from '../../../../common/helpers';
import { toggleCreateCampaignModal, addCampaign, editCampaign } from '../actions/campaigns-actions';
import { getSites } from '../../link-creator/actions/link-creator-actions';
import { validate } from '../validators/create-campaign-validators';

import '../styles/create-campaign-modal.css';

class CreateCampaignModal extends Component {
  state = {
    code: Helpers.generateRandomString(9),
    links: [],
    link: null,
  };

  componentDidMount() {
    const { link, change } = this.props;

    if (link) {
      change(campaignsConstants.fields.name, link.link_name);
      change(campaignsConstants.fields.invite_link, link.link_url);
      this.handleDropdownChange(null, link.link_url);
    }
  }

  closeModal() {
    const { toggleCreateCampaignModal } = this.props;

    toggleCreateCampaignModal(false);
  }

  handleDropdownChange(event, linkUrl) {
    const url = event && event.target ? event.target.value : linkUrl;
    const { sites } = this.props;
    const link = _.find(sites, { page_code: url });

    if (link) {
      this.setState({ link });
    }
  }

  handleFormSubmit(values) {
    const { code } = this.state;
    const { profile, addCampaign, editCampaign, link } = this.props;

    let data = {
      code,
      name: values.name,
      user_id: profile.user_id,
      additional_data: {
        invite_link: values.invite_link,
      },
    };

    if (link) {
      data.reference_code_id = link.reference_code_id;
      data.code = link.partner_code;
      editCampaign(data);
    } else {
      addCampaign(data);
    }
  }

  renderLinkAndDescription(selectedUrl, link) {
    const { t } = this.context;

    if (!selectedUrl || !link) {
      return null;
    }

    return (
      <table className="create-campaign-desc">
        <tr>
          <td className="row-label description">{t('CAMPAIGNS.CREATE_NEW_DESC')}</td>
          <td>{link.description}</td>
        </tr>
        <tr>
          <td className="row-label">{t('CAMPAIGNS.CREATE_NEW_LINK')}</td>
          <td>
            <a href={selectedUrl} target="_blank">
              {selectedUrl}
            </a>
          </td>
        </tr>
      </table>
    );
  }

  render() {
    const { showCreateCampaignModal, handleSubmit, createCampaignInProgress, sites, profile } = this.props;
    const { link, code } = this.state;
    const reason = link && campaignsConstants.special_campaigns.indexOf(link.page_name) !== -1 ? link.page_code : profile && profile.user_name;
    const selectedUrl = link
      ? Helpers.formUrl(link, {
          reason,
          refcode: code,
          code,
        })
      : '';

    return (
      <Modal visible={showCreateCampaignModal} effect="fadeInUp" onClickAway={() => this.closeModal()}>
        <div className="default-modal">
          <CloseBtn callback={this.closeModal.bind(this)} />
          <div className="text-center">
            <PageHeader title={this.props.link ? 'CAMPAIGNS.EDIT_CAMPAIGN' : 'CAMPAIGNS.CREATE_NEW'} />
          </div>
          <div className="row">
            <form onSubmit={handleSubmit(values => this.handleFormSubmit(values))} noValidate>
              <div className="row">
                <div className="col-md-12">
                  <Field name={campaignsConstants.fields.name} disabled={createCampaignInProgress} inputName={campaignsConstants.fields.name} label={'CAMPAIGNS.LINK_NAME'} component={DefaultInput} />
                </div>
                <div className="col-md-12 m-t-20">
                  <Field
                    name={campaignsConstants.fields.invite_link}
                    inputName={campaignsConstants.fields.invite_link}
                    label={'DASHBOARD.LINKS_LABEL'}
                    options={sites}
                    optionLabel={'page_name'}
                    optionValue={'page_code'}
                    disabled={createCampaignInProgress}
                    component={DefaultSelect}
                    onChange={e => this.handleDropdownChange(e)}
                  />
                </div>
                <div className="col-md-12 m-t-20">{this.renderLinkAndDescription(selectedUrl, link)}</div>
              </div>
              <div className="col-sm-6 col-xs-12">
                <Button disabled={createCampaignInProgress} label={'COMMON.SAVE'} customClass={`affiliate-btn-red m-t-20`} type={'submit'} />
              </div>
              <div className="col-sm-6 col-xs-12">
                <Button label={'COMMON.CLOSE'} customClass={`m-t-20`} onClick={() => this.closeModal()} type={'button'} />
              </div>
            </form>
          </div>
        </div>
      </Modal>
    );
  }
}

CreateCampaignModal.contextTypes = {
  t: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  showCreateCampaignModal: state.campaignsReducer.showCreateCampaignModal,
  createCampaignInProgress: state.campaignsReducer.createCampaignInProgress,
  link: state.campaignsReducer.link,
  sites: state.linkCreatorReducer.sites,
  profile: state.userProfileReducer.profile,
});

const mapDispatchToProps = dispatch => ({
  toggleCreateCampaignModal: show => {
    dispatch(toggleCreateCampaignModal(show));
  },
  addCampaign: data => {
    dispatch(addCampaign(data));
  },
  editCampaign: data => {
    dispatch(editCampaign(data));
  },
  getSites: (active, pageCode) => {
    dispatch(getSites(active, pageCode));
  },
});

CreateCampaignModal = reduxForm({
  form: campaignsConstants.create_campaign_form,
  validate,
})(CreateCampaignModal);

export default connect(mapStateToProps, mapDispatchToProps)(CreateCampaignModal);



// WEBPACK FOOTER //
// ./src/app/main/campaigns/components/create-campaign-modal.js